<template>
    <div>
        <!-- <p-button @click="onSaveUserPrivileges()" outline class="hover-text min float-right"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>                         

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" /> -->

        <b-table class="flex-container"
            :items="userPrivileges" 
            :fields="fields" 
            :sort-by.sync="sortBy"
            :filter="filter"
            @filtered="onFiltered"
            :per-page="perPage"
            :current-page="currentPage">

            <!-- <template v-slot:cell(selected)="{ item, index }">
                <input type="checkbox" :id="item.id" v-model="item.selected">
            </template> -->
            <template v-slot:cell(selected)="{ item }">
                <p class="mb-0">
                    <b-icon icon="check-circle" variant="success" v-if='item.selected' @click="toggleSelected(item)" 
                    font-scale="1.2" 
                    class="clickable"></b-icon>
                    <b-icon icon="x-circle" variant="secondary" v-if='!item.selected' @click="toggleSelected(item)" 
                    font-scale="1.2"
                    class="clickable"></b-icon>
                </p>
            </template>
            
        </b-table>

        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
    components: { TablePagination },
        props: ['filter', 'item'],
        data() {
            return {
                perPage: 10,
                currentPage: 1,
                filteredRows: 0,
                fields: [
                    { key: "id", label: this.$t('users.id'), sortable:"true" },
                    { key: "description", label: this.$t('users.description'), sortable:"true" },
                    { key: "selected", label: ""}
                ],
                sortBy:"id",               
                userPrivileges: [],
                ok: false,
                error: false,
                loading: false,
                savingPrivileges: false,
                infoType: "save"
            }
    },
    computed: {
        totalRows() {
            return this.filter ? this.filteredRows : (this.userPrivileges ? this.userPrivileges.length : 0);
        },               
        selectedUserPrivileges() {
            var selectedItems = [];
            
            for (var ug of this.userPrivileges) {
                if( ug.selected ) {
                    selectedItems.push(ug);
                }
            }
            return selectedItems;               
        }                             
    },
    created() {
        this.getUserPrivileges(this.item.id);
    },
    watch: {
        item: function(item) {
            this.getUserPrivileges(item.id);
            this.ok = this.error = this.loading = false;  
        }
    }, 
    methods: {
        listContains(item, list) {
            for(var i = 0; i < list.length; i++) {
                if(list[i].id === item.id) {
                    return true;
                }
            }
            return false;
        },    
        getUserPrivileges(item) {
            this.$store.dispatch('userDataHandler/getUsersGroups' , item ).then( response => {
                this.userPrivileges = response.data.privileges;
            });                
       },
       toggleSelected(item) {
            item.selected = !item.selected;
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            this.savingPrivileges = true;

            if (!this.selectedUserPrivileges || this.selectedUserPrivileges.length === 0) {
                this.$store.dispatch('userDataHandler/deleteUsersPrivileges', this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.$emit('updateItem', this.item);
                })
            } else {
                this.$store.dispatch('userDataHandler/saveUserPrivileges' , this.selectedUserPrivileges, this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.$emit('updateItem', this.item);
                })
            }
       },
       onSaveUserPrivileges() {
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('userDataHandler/saveUserPrivileges' , this.selectedUserPrivileges, this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.$emit('updateItem', this.item);
                })
            }, 1000);
        },
        onRowSelected(items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            if (!this.savingPrivileges) {
                this.currentPage = 1;
            } else {
                this.savingPrivileges = false;
            }
        },
        onPageChange(page){
            this.currentPage = page
        }
    }
}
</script>

<style scoped lang="scss" >

        .flex-container {
            display: flex;
            flex-wrap: wrap;
            max-height: 500px;
            width:450px;
            overflow:scroll;

        }

</style>